import React, { useEffect, useState, useContext } from "react";
import { UserContext } from '../contexts/UserContext';
import { CONFIG} from '../config';
import Loader from '../components/Loader';
import Navbar from './Navbar';

//import "./index.css";

const uploadCenterModules = [
  "DDR Metrics Report",
  "DL Dashboard Report",
  "Beacon Report",
  "Process Review Report",
  "Stage Gate Review Report",
  "Risks Issues Report",
  "PJPPJ Contracts Tagged for Review"
];

const apiUrl = CONFIG.REACT_APP_BACKEND_URL;
//const apiUrl='https://divadevfalcon.azurewebsites.net';
const userApiUrl=CONFIG.REACT_APP_BACKEND_URL +'/file_upload_users';
//const userApiUrl='https://divapilotfalcon-hdbqdbd4gxccdmdd.eastus-01.azurewebsites.net/file_upload_users';
const moduleConfig = {
  "DDR Metrics Report": {
    uploadApi:
      apiUrl+"/upload_ddr",
    moduleKey:'ddr_mmd',

    uploads: [
      {
        id: "metrics_file",
        apiField:"metrics_file",
        title: "Upload DDR Metrics Report File"
      },
      {
        id: "demographics_file1",
        apiField:"demographics_file",
        title: "Upload ProjectDemographics MyPortfolio Projects File"
      }
    ]
  },

  "DL Dashboard Report": {
    uploadApi:
      apiUrl+"/upload_dl_score",
    moduleKey:'dl_scorecard',
    uploads: [
      {
        id: "dl_file",
        apiField:"file",
        title: "Upload DL Dashboard Report"
      }
    ]
  },

  "Beacon Report": {
    uploadApi:
      apiUrl+"/upload_beacon",
    moduleKey:'beacon',
    uploads: [
      {
        id: "beacon_file",
        apiField:"file",
        title: "Upload Beacon Report"
      }
    ]
  },

  "Process Review Report": {
    uploadApi:
      apiUrl+"/upload_process_review",
    moduleKey:'Process Review',
    uploads: [
      {
        id: "process_review_file",
        apiField:"process_review_file",
        title: "Upload Process Review Report"
      },
      {
        id: "demographics_file2",
        apiField:"demographics_file",
        title: "Upload ProjectDemographics MyPortfolio Projects File"
      }
    ]
  },

  "Stage Gate Review Report": {
    uploadApi:
      apiUrl+"/upload_sgr",
    moduleKey:'SGR',
    uploads: [
      {
        id: "sgr_file",
        apiField:"sgr_file",
        title: "Upload Stage Gate Review Report"
      },
      {
        id: "demographics_file3",
        apiField:"demographics_file",
        title: "Upload ProjectDemographics MyPortfolio Projects File"
      }
    ]
  },

  "Risks Issues Report": {
    uploadApi:
      apiUrl+"/upload_risk_issue_offline",
    moduleKey:'Offline Risks/Issues',
    uploads: [
      {
        id: "risk_issues",
        apiField:"risk_issue_file",
        title: "Upload Risks Issues Report"
      }
    ]
  },

  "PJPPJ Contracts Tagged for Review": {
    uploadApi:apiUrl+"/upload_focus_pjppj",
    moduleKey:'Focus_PJPPJ',
    uploads: [
      {
        id: "focus_file",
        apiField:"focus_file",
        title: "Upload Focus Job List"
      },
      {
        id: "pjppj_file",
        apiField:"pjppj_file",
        title: "Upload PJPPJ Contracts Tagged for Review"
      },
      {
        id: "demographics_file",
        apiField:"demographics_file",
        title: "Upload Project Demographics Contract Data"
      }
    ]
  }
};

function formatDate(dateString) {
    if (!dateString) return "";

    const date = new Date(dateString);

    const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
}


function UploadCenter() {
  const [selectedModule, setSelectedModule] =
    useState(uploadCenterModules[0]);

  const [activeTab, setActiveTab] =
    useState("upload");

  const [uploadedFiles, setUploadedFiles] =
    useState({});

  const [showUploadConfirmation,
    setShowUploadConfirmation] =
    useState(false);

  const [isUploading, setIsUploading] =
    useState(false);

  const [validationError,
    setValidationError] =
    useState("");

  const [successMessage,
    setSuccessMessage] =
    useState("");

  const [historyData,
    setHistoryData] =
    useState([]);

  const [lastUploadInfo,
    setLastUploadInfo] =
    useState({
      uploadedDate: "-",
      uploadedFiles: []
    });
  
  //const { contractsContext, setContractsContext } = useContext(UserContext);
  const { userId } = useContext(UserContext);
    console.log('userId',userId); 
  const [isAcitveUser, setIsAcitveUser] = useState(false);
 const [activeMenu, setActiveMenu] = useState("upload");
useEffect(() => {

    const loadUser = async () => {

        if (!userId) {

            setIsAcitveUser(false);
            setLoading(false);

            return;
        }

        try {

            setLoading(true);

            const response = await fetch(
                `${userApiUrl}?username=${userId.split("@")[0]}`
            );

            const data = await response.json();

            console.log("User Data", data);

            if (
                data &&
                data.records &&
                data.records.length > 0
            ) {

                setIsAcitveUser(true);
                loadUsers();


            } else {

                setIsAcitveUser(false);

            }

        } catch (error) {

            console.error(error);

            setIsAcitveUser(false);

        } finally {

            setLoading(false);

        }

    };
    loadUser();    
}, [userId]);

const currentModuleConfig =
  moduleConfig[selectedModule];

  useEffect(() => {
    loadModuleHistory();
  }, [selectedModule]);



  const loadModuleHistory = async () => {
    try {

      // Replace with actual API

     setLoading(true); 
      const response = await fetch(
        apiUrl+'/fetch_ingestion_history'
      );

      const data = await response.json();

 const sortedHistory = [...data.data].sort(
    (a, b) =>
        new Date(b.created_at) -
        new Date(a.created_at)
);
console.log('sortedHistory',sortedHistory);

const moduleHistory = sortedHistory.filter(
    item =>
        item.module?.toLowerCase() ===
        currentModuleConfig.moduleKey.toLowerCase()
);

console.log('moduleHistory',moduleHistory);

setHistoryData(moduleHistory);

if (moduleHistory.length > 0) {

    setLastUploadInfo({

        uploadedDate: formatDate(
            moduleHistory[0].updated_at
        ),

        uploadedFiles: moduleHistory[0].file_name

    });

}
else {

    setLastUploadInfo({

        uploadedDate: "-",
        uploadedFiles: []

    });

}

    } catch (error) {
      console.error(error);
      setLoading(false);
    }
    setLoading(false);
  };

     const [users, setUsers] = useState([]);
     const [oldUserName, setOldUserName] = useState("");
     const [showDeleteModal, setShowDeleteModal] = useState(false);

const [selectedUser, setSelectedUser] = useState(null);

const [isDeletingUser, setIsDeletingUser] = useState(false);

    const [searchText, setSearchText] = useState("");

    console.log('users records',users);

    const filteredUsers = users.filter(user =>
        user.name.toLowerCase().includes(searchText.toLowerCase()) ||
        user.create_by.toLowerCase().includes(searchText.toLowerCase())
    );

    const loadUsers = async () => {

    try {

        setLoading(true);

        const response = await fetch(userApiUrl);

        const data = await response.json();
        console.log('user data',data);

        const formattedUsers = data.records.map(record => ({
            id: record[0],
            name: record[1],
            create_by: record[2],
            created_at: record[3],
            status: record[4] ? "Active" : "Inactive"
        }));
        console.log('formattedUsers',formattedUsers);

        setUsers(formattedUsers);

    } catch (error) {

        console.error(error);

    } finally {

        setLoading(false);

    }

};

const confirmDeleteUser = (user) => {

    setSelectedUser(user);

    setShowDeleteModal(true);

};

const deleteUser = async () => {

    try {

        setIsDeletingUser(true);

        const formData = new FormData();

        formData.append(
            "username",
            selectedUser.name
        );

        formData.append(
            "operation",
            "delete"
        );

        const response = await fetch(
            userApiUrl,
            {
                method: "POST",
                body: formData
            }
        );

        const data = await response.json();

        if (!response.ok) {

            throw new Error(
                data.message ||
                "Delete failed."
            );

        }

        setShowDeleteModal(false);

        setSelectedUser(null);

        await loadUsers();

        showNotification("success",data.message);

    }
    catch(error){

        showNotification("error", error.message);

    }
    finally{

        setIsDeletingUser(false);

    }

};

    const [showUserModal, setShowUserModal] = useState(false);

    const [isEditMode, setIsEditMode] = useState(false);

    const [isSavingUser, setIsSavingUser] = useState(false);

    const [selectedMenu, setSelectedMenu] = useState("DDR Metrics Report");

    const [loading, setLoading] = useState(false);

    const [userForm, setUserForm] = useState({
        id: null,
        name: "",
        create_by: "",
        created_at: "",
        status: true
    });

    const [notification, setNotification] = useState({
    show: false,
    type: "",      // success | error
    message: ""
    });

  const showNotification = (type, message) => {

    setNotification({
        show: true,
        type,
        message
    });

    setTimeout(() => {

        setNotification({
            show: false,
            type: "",
            message: ""
        });

    }, 3000);

};
  
  const openAddUser = () => {

    setIsEditMode(false);

    setUserForm({
        id: null,
        name: "",
        create_by: "",
        created_at: "",
        status: true
    });

    setShowUserModal(true);

};

const openEditUser = (user) => {

    setIsEditMode(true);
    setOldUserName(user.name);

    setUserForm({
        ...user
    });

    setShowUserModal(true);

};
const saveUser = async () => {

    try {
        setLoading(true);
        setIsSavingUser(true);

        const operation = isEditMode
            ? "update"
            : "insert";
        console.log('userForm',userForm);
const formdata = new FormData();

if(isEditMode) {
formdata.append("old_username", oldUserName);
formdata.append("new_username", userForm.name);
} else formdata.append("username", userForm.name);
formdata.append("created_by", userId.split("@")[0]);
formdata.append("operation", operation);
console.log('operation',operation);

const requestOptions = {
  method: "POST",
  body: formdata
};

        const response = await fetch(userApiUrl, requestOptions);
        const data = await response.json();
        console.log('data',data);

        if (!response.ok) {
            throw new Error(data.message);
        }

        setShowUserModal(false);

        await loadUsers(); // Refresh user list

        showNotification("success",data.message);

    } catch (error) {

        showNotification("error", error.message);

    } finally {

        setIsSavingUser(false);
        setLoading(false);

    }

};
  const handleFileChange = (
    uploadId,
    event
  ) => {

    const file =
      event.target.files[0];

    if (!file) return;

    setUploadedFiles((prev) => ({
      ...prev,
      [uploadId]: file
    }));

    setValidationError("");
    setSuccessMessage("");
  };

  const handleSubmit = () => {

const missingFiles =
  currentModuleConfig.uploads.filter(
    (item) =>
      !uploadedFiles[item.id]
  );

if (missingFiles.length > 0) {
  setValidationError(
    "Please upload all required files."
  );
  return;
}

    setValidationError("");

    setShowUploadConfirmation(true);
  };


    const uploadFiles = async () => {

    try {

        setIsUploading(true);

        setValidationError("");
        setSuccessMessage("");

        const formData = new FormData();

        currentModuleConfig.uploads.forEach(
            (uploadItem) => {

                formData.append(
                    uploadItem.apiField,
                    uploadedFiles[uploadItem.id]
                );

            }
        );

        formData.append(
            "moduleName",
            selectedModule
        );

        formData.append(
            "user",
            userId
        );

        const response = await fetch(
            currentModuleConfig.uploadApi,
            {
                method: "POST",
                body: formData
            }
        );

        const responseData =
            await response.json();

        if (!response.ok) {

            throw new Error(
                responseData.message ||
                "Upload Failed"
            );

        }

        setShowUploadConfirmation(false);

        setUploadedFiles({});
       
        showNotification("success", responseData.message || "Files uploaded successfully.");

        await loadModuleHistory();

    } catch (error) {

        setShowUploadConfirmation(false);

        setValidationError(
            error.message ||
            "Upload failed. Please try again."
        );

    } finally {

        setIsUploading(false);
        
    }



};

 
    return ( 
        <div className="container">
      <Navbar />  
          {!isAcitveUser && <div className='errorClass'><br/>
          <h3>Access Denied</h3>
<p>You don't have the required permissions to view this page. Please contact your administrator if you need access.</p>
          </div>  }    
    { isAcitveUser &&
    <div className="uploadCenterLayout">

      {/* LEFT SIDEBAR */}
      


      <div className="uploadCenterSidebarPanel">
              <div className="uploadCenterAdminSection">

    <div className="uploadCenterSidebarHeading">
        Administration
    </div>

    <button
        className={`uploadCenterMenuButton ${
            activeMenu === "users"
                ? "uploadCenterMenuButtonActive"
                : ""
        }`}
        onClick={() => {setActiveMenu("users"); setSelectedMenu("users"); setSelectedModule("")}}
    >
        User Management
    </button>

</div>

        <div className="uploadCenterSidebarHeading">
          Upload Center
        </div>

        {uploadCenterModules.map(
          (moduleName) => (
            <button
              key={moduleName}
              className={`uploadCenterMenuButton ${
                selectedModule ===
                moduleName
                  ? "uploadCenterMenuButtonActive"
                  : ""
              }`}
              onClick={() => {

                setSelectedMenu(moduleName);

                setSelectedModule(
                  moduleName
                );
                setActiveMenu("upload");

                setUploadedFiles({});

                setValidationError("");

                setSuccessMessage("");

              }}
            >
              {moduleName}
            </button>
          )
        )}

      </div>

      {/* RIGHT CONTENT */}

      <div className="uploadCenterContentArea">
        {loading && <Loader loadingtxt='Loading details, Please hold on a moment' />}
        {
notification.show && (

<div
    className={
        notification.type === "success"
        ? "uploadCenterToastSuccess"
        : "uploadCenterToastError"
    }
>

    <span>

        {
            notification.type === "success"
            ? "✔"
            : "✖"
        }

    </span>

    <span>

        {notification.message}

    </span>

</div>

)
}
 {
        activeMenu === "users"
        ? (
 
        <div className="uploadCenterMainCard">

            <div className="uploadCenterHeader">

                <h2>User Management</h2>

                <button
                    className="uploadCenterPrimarySubmitButton"
                    onClick={openAddUser}
                >
                    + Add User
                </button>

            </div>

            <div
                style={{
                    marginTop:15,
                    marginBottom:20
                }}
            >

                <input
                    type="text"
                    placeholder="Search User..."
                    value={searchText}
                    onChange={(e)=>
                        setSearchText(e.target.value)
                    }
                    className="uploadCenterSearchBox"
                />

            </div>

            <table className="uploadCenterHistoryTable">

                <thead>

                    <tr>

                        <th>User Name</th>

                        <th>Created By</th>
                      
                        <th>Edit</th>

                        <th>Delete</th>

                    </tr>

                </thead>

                <tbody>

                    {
                        filteredUsers.length===0 ?

                        <tr>

                            <td
                                colSpan="6"
                                style={{
                                    textAlign:"center"
                                }}
                            >
                                No Users Found
                            </td>

                        </tr>

                        :

                        filteredUsers.map(user=>(

                            <tr key={user.id}>

                                <td>{user.name}</td>

                                <td>{user.create_by}</td>

                                <td>

                                    <button
                                        className="uploadCenterSmallButton"
                                        onClick={()=>
                                            openEditUser(user)
                                        }
                                    >
                                        Edit
                                    </button>

                                </td>

                                <td>

                                    <button
                                        className="uploadCenterDeleteButton"
                                        onClick={()=>
                                            confirmDeleteUser(user)
                                        }
                                    >
                                        Delete
                                    </button>

                                </td>

                            </tr>

                        ))

                    }

                </tbody>

            </table>
{
showDeleteModal && (

<div className="uploadCenterUserModalOverlay">

    <div className="uploadCenterDeleteModal">

        <div className="uploadCenterUserModalHeader">

            <h3>
                Delete User
            </h3>

        </div>

        <div className="uploadCenterUserModalBody">

            <p>

                Are you sure you want to delete

                <b>
                    {" "}
                    {selectedUser?.name}
                    {" "}
                </b>

                ?

            </p>

           
        </div>

        <div className="uploadCenterUserModalFooter">

            <button
                className="uploadCenterUserCancelButton"
                onClick={() => {

                    setShowDeleteModal(false);

                    setSelectedUser(null);

                }}
            >
                Cancel
            </button>

            <button
                className="uploadCenterDeleteButton"
                disabled={isDeletingUser}
                onClick={deleteUser}
            >
                {
                    isDeletingUser
                        ? "Deleting..."
                        : "Delete"
                }
            </button>

        </div>

    </div>

</div>

)
}

{showUserModal && (



<div className="uploadCenterModalOverlay">

    <div className="uploadCenterModal">

        <h3>
            {isEditMode ? "Edit User" : "Add User"}
        </h3>

<div className="uploadCenterUserFormGrid">

    <div className="uploadCenterUserFormGroup">

        <label className="uploadCenterUserFormLabel">
            User Name
            <span className="uploadCenterUserRequired">*</span>
        </label>

        <input
            type="text"
            className="uploadCenterUserInput"
            placeholder="Enter User Name"
            value={userForm.name}
            onChange={(e) =>
        setUserForm(prev => ({
            ...prev,
            name: e.target.value
        }))
    }
        />

    </div>

</div>

        <div className="uploadCenterModalButtons">

            <button
                onClick={() =>
                    setShowUserModal(false)
                }
            >
                Cancel
            </button>

            <button
                disabled={isSavingUser}
                onClick={saveUser}
            >
                {
                    isSavingUser
                        ? "Saving..."
                        : isEditMode
                            ? "Update"
                            : "Save"
                }
            </button>

        </div>

    </div>

</div>

)}
        </div>
        )
        : (
        <div className="uploadCenterMainCard">

          <div className="uploadCenterPageHeader">

            <h1 className="uploadCenterPageTitle">
              {selectedModule}
            </h1>

            <p className="uploadCenterPageDescription">
              Upload and manage files for
              {selectedModule}
            </p>

          </div>

          {/* TABS */}

          <div className="uploadCenterTabsWrapper">

            <button
              className={`uploadCenterTabButton ${
                activeTab === "upload"
                  ? "uploadCenterTabButtonActive"
                  : ""
              }`}
              onClick={() =>
                setActiveTab(
                  "upload"
                )
              }
            >
              File Upload
            </button>

            <button
              className={`uploadCenterTabButton ${
                activeTab === "history"
                  ? "uploadCenterTabButtonActive"
                  : ""
              }`}
              onClick={() =>
                setActiveTab(
                  "history"
                )
              }
            >
              History
            </button>

          </div>

          {/* UPLOAD TAB */}

          {activeTab ===
            "upload" && (

            <>

              {/* SUMMARY */}

              <div className="uploadCenterSummaryCardsWrapper">

                <div className="uploadCenterSummaryInfoCard">

                  <h4>
                    Last Uploaded Date
                  </h4>

                  <div>
                    {
                      lastUploadInfo.uploadedDate
                    }
                  </div>

                </div>

                <div className="uploadCenterSummaryInfoCard">

                  <h4>
                    Last Uploaded Files
                  </h4>

                  {lastUploadInfo.uploadedFiles
                    .length === 0 ? (
                    <div>
                      No uploads found
                    </div>
                  ) : (
                    
                        <div
                          key={
                            lastUploadInfo.uploadedFile
                          }
                        >
                          {lastUploadInfo.uploadedFiles}
                        </div>
                    
                  )}

                </div>

              </div>

              {/* FILE UPLOADS */}

              <div
                className={`uploadCenterFileUploadSection ${
                  currentModuleConfig
                    .uploads.length ===
                  1
                    ? "uploadCenterSingleUploadSection"
                    : ""
                }`}
              >

                {currentModuleConfig.uploads.map(
                  (
                    uploadItem
                  ) => (
                    <UploadFileCard
                      key={
                        uploadItem.id
                      }
                      uploadId={
                        uploadItem.id
                      }
                      title={
                        uploadItem.title
                      }
                      file={
                        uploadedFiles[
                          uploadItem.id
                        ]
                      }
                      onFileChange={
                        handleFileChange
                      }
                    />
                  )
                )}

              </div>

              {validationError && (

                <div className="uploadCenterErrorMessage">
                  {
                    validationError
                  }
                </div>

              )}

              <div className="uploadCenterSubmitButtonWrapper">

                <button
                    className="uploadCenterPrimarySubmitButton"
                    disabled={isUploading}
                    onClick={handleSubmit}
                >
                    {isUploading
                        ? "Uploading..."
                        : "Submit"}
                </button>

              </div>

            </>

          )}

          {/* HISTORY TAB */}

          {activeTab ===
            "history" && (

            <div className="uploadCenterHistoryWrapper">

              <table className="uploadCenterHistoryTable">

                <thead>

                  <tr>

                    <th>
                      File Name
                    </th>

                    <th>
                      Uploaded By
                    </th>

                    <th>
                      Upload Date
                    </th>

                    <th>
                      Status
                    </th>

                  </tr>

                </thead>

                <tbody>

                  {historyData.length ===
                  0 ? (

                    <tr>

                      <td
                        colSpan="4"
                        className="uploadCenterNoData"
                      >
                        No History Found
                      </td>

                    </tr>

                  ) : (

                    historyData.map(
                      (
                        item
                      ) => (

                        <tr
                          key={
                            item.id
                          }
                        >

                          <td>
                            {
                              item.file_name
                            }
                          </td>

                          <td>
                            {
                              item.uploaded_by
                            }
                          </td>

                          <td>
                            {
                              formatDate(item.created_at)
                            }
                          </td>

                          <td>

                            <span
    className={
        item.status === "FAILED"
            ? "uploadCenterStatusFailure"
            : "uploadCenterStatusSuccess"
    }
    title={
        item.status === "FAILED"
            ? item.logs
            : ""
    }
>
    {item.status}
</span>

                          </td>

                        </tr>

                      )
                    )

                  )}

                </tbody>

              </table>

            </div>

          )}
                    {/* CONFIRMATION MODAL */}

          {showUploadConfirmation && (

            <div className="uploadCenterModalOverlay">

              <div className="uploadCenterModal">

                <h3>
                  Are you sure you want to
                  upload the selected file(s)?
                </h3>

                <div className="uploadCenterModalButtons">

                  <button
                    type="button"
                    onClick={() =>
                      setShowUploadConfirmation(
                        false
                      )
                    }
                  >
                    Cancel
                  </button>

                  <button
                    disabled={isUploading}
                    onClick={uploadFiles}>
                    {isUploading
                        ? "Uploading..."
                        : "Yes Upload"}
                </button>

                </div>

              </div>

            </div>

          )}

        </div>
        )}
      </div>

    </div> }
    </div>
  );
}

/* ==========================================
   FILE CARD COMPONENT
========================================== */

function UploadFileCard({
  uploadId,
  title,
  file,
  onFileChange
}) {

  return (

    <div className="uploadCenterFileUploadCard">

      <div className="uploadCenterFileUploadIcon">
        ☁
      </div>

      <h3>{title}</h3>

      <label className="uploadCenterBrowseFileButton">

        Browse File

        <input
          type="file"
          hidden
          onChange={(event) =>
            onFileChange(
              uploadId,
              event
            )
          }
        />

      </label>

      {file && (

        <div className="uploadCenterSelectedFileName">

          {file.name}

        </div>

      )}

    </div>

  );
}

export default UploadCenter;